import(/* webpackMode: "eager", webpackExports: ["ComparisonPage"] */ "/app/apps/frontend/marketing/components/comparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/app/apps/frontend/marketing/components/nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ONARK_TRAINING_PATH","TrainingLink"] */ "/app/apps/frontend/marketing/components/training-link.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
